let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dRgFn")).then(() => parcelRequire('c0Tkr'));